export default "__VITE_ASSET__irZUFIoA__"